"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = __importDefault(require("@bambeehr/currency"));
const payroll_1 = require("../constants/payroll");
function toHourlyRate(payType, payRate) {
    if (payType === payroll_1.PayTypes.SALARY) {
        return (0, currency_1.default)(payRate, {}).divide(2080).value;
    }
    return (0, currency_1.default)(payRate, {}).value;
}
exports.default = toHourlyRate;
//# sourceMappingURL=toHourlyRate.js.map